<template>
    <div>
        <div class="col-sm-12 nopads pt-2">
            <Transition name="fade">
                <inspection-list
                    :results="results"
                    @add="addInspection"
                    @edit="editInspection"
                    @copy="copyInspection"
                />
            </Transition>

            <base-modal
                v-if="editMode && inspection"
                size="xl"
                :hide-header="true"
                :hide-footer="true"
            >
                <inspection-editor
                    :inspection="inspection"
                    @close="showInspectionList"
                    @closeAndUpdate="closeAndUpdate"
                />
            </base-modal>

            <div
                v-if="loading"
                id="loader"
                class="spinner"
            />
        </div>
    </div>
</template>

<script>
import {restApi} from '../mixins/RestApiMixin'
import InspectionList from './InspectionList'
import InspectionEditor from './InspectionEditor'
import {inspectionHelper} from '../mixins/InspectionMixin'
import BaseModal from "@/components/BaseModal";

export default {
    name: 'Inspections',
    components: {BaseModal, InspectionEditor, InspectionList},
    mixins: [restApi, inspectionHelper],
    data: function () {
        return {
            results: [],
            inspection: null,
            editMode: false,
            loading: true
        }
    },
    mounted: function () {
        this.fetchInspections()
    },
    methods: {
        fetchInspections: function () {
            this.loading = true
            this.results = []
            this.restFetch(this.inspectionTemplateUrl, this.handleResponse)
        },
        handleResponse: function (response) {
            this.loading = false
            if (response?.data) {
                response.data.sort((a, b) => a.name.localeCompare(b.name));
                this.results = response.data
            }
        },
        copyInspection: function (inspection) {
            const copy = this.jsonToInspection(inspection)
            copy.id = -1
            copy.name = copy.name + ' (' + this.$t('inspection_template.copy').toLowerCase() + ')'
            this.inspection = copy
            this.editMode = true
        },
        addInspection: function () {
            this.inspection = this.newInspection()
            this.editMode = true
        },
        editInspection: function (inspection) {
            this.inspection = inspection
            this.editMode = true
        },
        showInspectionList: function () {
            this.editMode = false
        },
        closeAndUpdate: function () {
            this.fetchInspections()
            this.showInspectionList()
        }

    }
}
</script>
editInspectable
